import { FieldType, SettingFieldResponse } from '@business/entities/settingFields';
import { formControl, Validators } from '@core/utils/form';
import { defineCustomAddressForm } from './AddressCustomField';
import { CustomFieldResponseType } from '@business/entities/integration';
import { toMoment } from '@core/utils/time';

export function getTitle(type: FieldType) {
  switch (type) {
    case FieldType.text:
      return 'Text';
    case FieldType.autocomplete:
      return 'Auto Complete';
    case FieldType.largetext:
      return 'Large Text';
    case FieldType.numerical:
      return 'Numerical';
    case FieldType.multiOptions:
      return 'Multi Options';
    case FieldType.singleOption:
      return 'Single Option';
    case FieldType.phone:
      return 'Phone';
    case FieldType.dropdown:
      return 'Drop Down';
    case FieldType.datepicker:
      return 'Date Picker';
    case FieldType.address:
      return 'Address';
    case FieldType.file:
      return 'File';
    case FieldType.html:
      return 'HTML';
    case FieldType.user:
      return 'User Dropdown';
  }
}

export function getFormControl(field: SettingFieldResponse, fillRequired = true, isImport = false) {
  switch (field.type) {
    case FieldType.user:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.text:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.address:
      if (isImport) {
        return formControl<string>({
          label: field.label,
          required: field.required && fillRequired,
          initialValue: field.value || 'US',
        });
      }
      return defineCustomAddressForm(field, fillRequired);
    case FieldType.autocomplete:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.datepicker:
      return formControl<number>({
        label: field.label,
        required: field.required && fillRequired,
        initialValue: field.for === 'deals' ? toMoment().unix() : 0,
      });
    case FieldType.dropdown:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.file:
      return formControl<CustomFieldResponseType>({
        label: field.label,
        required: field.required,
      });
    case FieldType.html:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.largetext:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.multiOptions:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
    case FieldType.numerical:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
        validators: [Validators.number],
      });
    case FieldType.phone:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
        initialValue: field.value || 'us',
      });
    case FieldType.singleOption:
      return formControl<string>({
        label: field.label,
        required: field.required && fillRequired,
      });
  }
}

export function hasFile(customFields?: { [key: string]: CustomFieldResponseType }) {
  if (!customFields) return false;
  return Object.keys(customFields).some(key => {
    return customFields[key] instanceof File;
  });
}
